import ImageOne from "../images/backlodge.jpg";
import ImageTwo from "../images/air.jpg";
import ImageThree from "../images/sidelodge.jpg";
import ImageFour from "../images/water.jpg";
import ImageFive from "../images/sunset.jpg";
import ImageSix from "../images/before.jpg";
import specialone from "../images/specialone.jpg";
import specialtwo from "../images/specialtwo.jpg";
import ImageSeven from "../images/foodone.jpg";
import ImageEight from "../images/foodtwo.jpg";
import ImageNine from "../images/foodthree.jpg";
import ImageTen from "../images/foodfour.jpg";
import ImageEleven from "../images/foodfive.jpg";
import story from "../images/story.jpg";
import maria from "../images/mariajonathan.jpg";
import jonathan from "../images/mariajonathantwo.jpg";
import ImageTwelve from "../images/cafemenuone.jpg";
import ImageThirteen from "../images/cafemenutwo.jpeg";
import ImageFourteen from "../images/treatthree.jpg";
import ImageFifteen from "../images/treatfour.jpg";
import ImageSixteen from "../images/treatfive.jpg";

import ImageSeventeen from "../images/partyone.jpg";
import ImageEighteen from "../images/partytwo.jpg";
import ImageNineteen from "../images/partythree.jpg";
import ImageTwenty from "../images/partyfour.jpg";
import ImageTwentyOne from "../images/partyfive.jpg";

import pastel from "../images/pastel.jpg";
import caketwo from "../images/caketwo.jpg";
import pasteldos from "../images/pasteldos.jpg";
import pasteltres from "../images/pasteltres.jpg";
import pastelcuatro from "../images/pastelcuatro.jpg";
import pastelcinco from "../images/pastelcinco.jpg";
import vino from "../images/vino.jpg";
import vinodos from "../images/vinodos.jpg";
import vaso from "../images/vaso.jpg";
import vasodos from "../images/vasodos.jpg";
import vasotres from "../images/vasotres.jpg";
import vasocuatro from "../images/vasocuatro.jpg";

export const InfoData = {
  heading: "Explore our beautiful rooms",
  paragraphOne:
    "lorem impsjlkdjfs ;kfslkj fs;lkj a;jslk jfslkj skl;lkjslkfj;lskj f;dlsjf sd;ljssdjsldkjf",
  paragraphTwo:
    "lorem.ipsum.paragraph sldkfj sd;lkf jsdlkf sdj;lkf sj;lkfj sd;lkf jsd;lkfj sd;lfkjsd;lkf jsd;fkl sjd",
  buttonLabel: "View Room",
  image: ImageOne,
  reverse: false,
  delay: 350,
};

export const InfoDataTwo = {
  heading: "Modern Designs",
  paragraphOne:
    "lorem impsjlkdjfs ;kfslkj fs;lkj a;jslk jfslkj skl;lkjslkfj;lskj f;dlsjf sd;ljssdjsldkjf",
  paragraphTwo:
    "lorem.ipsum.paragraph sldkfj sd;lkf jsdlkf sdj;lkf sj;lkfj sd;lkf jsd;lkfj sd;lfkjsd;lkf jsd;fkl sjd",
  buttonLabel: "View Room",
  image: ImageTwo,
  reverse: true,
  delay: 400,
};

export const InfoDataThree = {
  heading: "Truly enjoy your special moment surrounded by love and nature",
  paragraphTwo:
    "Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle less than a mile from the Blue Ridge Parkway entrance and three miles from I-26.Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle les",
  image: ImageTwo,
  image2: ImageOne,
  image3: ImageThree,
  image4: ImageFour,
  image5: ImageFive,
  image6: ImageSix,
  reverse: true,
  delay: 400,
};
export const InfoDataFive = {
  heading: "Truly enjoy your special moment surrounded by love and nature",
  paragraphTwo:
    "Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle less than a mile from the Blue Ridge Parkway entrance and three miles from I-26.Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle les",
  image: pastel,
  image2: caketwo,
  image3: pasteldos,
  image4: pasteltres,
  image7: pastelcuatro,
  image6: pastelcinco,
  image5: vino,
  image8: vinodos,
  image9: vaso,
  image10: vasodos,
  image11: vasotres,
  image12: vasocuatro,

  reverse: true,
  delay: 400,
};
export const InfoDataSix = {
  heading: "Truly enjoy your special moment surrounded by love and nature",
  paragraphTwo:
    "Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle less than a mile from the Blue Ridge Parkway entrance and three miles from I-26.Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle les",
  image: ImageTwelve,
  image2: ImageThirteen,
  reverse: true,
  delay: 400,
};

export const InfoDataEight = {
  heading: "Truly enjoy your special moment surrounded by love and nature",
  paragraphTwo:
    "Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle less than a mile from the Blue Ridge Parkway entrance and three miles from I-26.Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle les",
  image: ImageSeventeen,
  image2: ImageEighteen,
  image5: ImageNineteen,
  image7: ImageTwentyOne,
  image4: ImageTwenty,
  reverse: true,
  delay: 400,
};

export const InfoDataNine = {
  heading: "Truly enjoy your special moment surrounded by love and nature",
  paragraphTwo:
    "Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle less than a mile from the Blue Ridge Parkway entrance and three miles from I-26.Bent Creek Lodge, an Asheville Bed and Breakfast, has the best of all worlds for visitors to the area. The lodge is located only 10 miles from the center of Asheville or the famous Biltmore Estate; yet nestled in a forested triangle les",
  image: story,
  reverse: true,
  delay: 400,
};

export const InfoDataTen = {
  image: maria,
  reverse: true,
  delay: 400,
};

export const InfoDataEleven = {
  image: jonathan,
  reverse: true,
  delay: 400,
};

export const InfoDataFour = {
  heading: "Sign up to our Newsletter!",
  paragraphTwo:
    "Welcome to our newsletter signup page. Below is a form that you can fill out if you'd like to recieve our newsletters with updates on the Cabin, discounts, and latest news. We appreciate your business and can't wait to see you at Little Heaven Bed & Breakfast!",
  delay: 400,
};

export const InfoDataSeven = {
  heading: "Yadkin Valley Dining!",
  paragraphOne:
    " Asheville NC Restaurants offers an amazing choice of dining options from gourmet worldly presentations to down-home country delights. Almost all are independently owned. According to YELP!, Asheville is the #1 destination for foodies in 2020. Conde Naste magazine listed Asheville as its top 3 must see destinations. The April 2020 edition of Southern Living magazine listed these “Best Of” categories with local winners to try: #3 Best Local Restaurant: Curate #8 Best BBQ: Buxton Hall Barbecue #9 Best New Restaurant: Beene on Eagle These are a few of our favorite Asheville NC Restaurants but we have a host of others to suggest at the cabin. Nearly all of the restaurants offer casual dining, but reservations are recommended for weekends to ensure you can enjoy your favorite spot. We’re happy to offer suggestions and help you make dinner reservations during your stay. Limones – An all together different world of Mexican/Californian Cuisine, Downtown. 828-252-2327.",

  paragraphTwo:
    "    Chestnut – New American eatery for seasonal bites & homemade treats in restored 1920s digs with a full bar. Downtown 828-575-2667.Posana – Contemporary American cuisine featuring local ingredients served in a chic space with a patio–Dedicated Gluten Free Kitchen, downtown. (828) 505-3969.Salsa’s – A funky, innovative blend of Caribbean flavors, downtown. 828-252-9805",
  image: ImageTwo,
  image2: specialtwo,
  image7: specialone,
  image3: ImageThree,
  image5: ImageOne,
  image4: ImageFour,
};

export const categories = [
  {
    id: 1,
    img: ImageOne,
    title: "Room Sale!",
  },
  {
    id: 1,
    img: ImageTwo,
    title: "Explore the Cabin!",
  },
  {
    id: 1,
    img: ImageOne,
    title: "A stay to remember",
  },
];
